import * as I from '@/interfaces';

class AxStorageImpl {
  getNumber(key: string) {
    const raw = localStorage.getItem(key) || '0';
    const num = Number.parseInt(raw);

    if (num === NaN) return 0;
    return num;
  }

  setNumber(key: string, value: number) {
    if (typeof value !== 'number') return;

    if (value) {
      localStorage.setItem(key, value.toString());
    } else {
      localStorage.removeItem(key);
    }
  }

  getBoolean(key: string) {
    return localStorage.getItem(key) === 'true';
  }

  setBoolean(key: string, value: boolean | null) {
    if (value !== null) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.removeItem(key);
    }
  }

  getString(key: string) {
    return localStorage.getItem(key) || '';
  }

  setString(key: string, value: string) {
    if (value.length > 0) {
      localStorage.setItem(key, value);
    } else {
      localStorage.removeItem(key);
    }
  }

  getObject<T>(key: string) {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      return JSON.parse(raw) as T;
    } catch {}

    return null;
  }

  setObject<T>(key: string, value: T | null) {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.removeItem(key);
    }
  }

  get axToken() {
    return this.getString('ax-token');
  }

  set axToken(value: string) {
    this.setString('ax-token', value);
  }

  get axZone() {
    return this.getNumber('ax-zone');
  }

  set axZone(value: number) {
    this.setNumber('ax-zone', value);
  }

  get skipLogin() {
    return this.getBoolean('skipLogin');
  }

  set skipLogin(value: boolean | null) {
    this.setBoolean('skipLogin', value);
  }

  get saveCheckUser() {
    return this.getBoolean('saveCheckUser');
  }

  set saveCheckUser(value: boolean | null) {
    this.setBoolean('saveCheckUser', value);
  }

  get saveUser() {
    return this.getString('saveUser');
  }

  set saveUser(value: string) {
    this.setString('saveUser', value);
  }

  get latestInfo() {
    return this.getObject<I.AxLatestInfo>('latestInfo');
  }

  set latestInfo(info: I.AxLatestInfo | null) {
    this.setObject<I.AxLatestInfo>('latestInfo', info);
  }

  get axDevScroll() {
    return this.getNumber('ax-dev-scroll');
  }

  set axDevScroll(value: number) {
    this.setNumber('ax-dev-scroll', value);
  }
}

export const AxStorage = new AxStorageImpl();
